<template>
    <div class="wizardStep" :class="{'active': combo.isActive}">
        <div class="title-container" @click="toggleHideGroup">
            <div class="left-part-title">
                <span class="circle" v-text="getGroupNumber()"></span>
                <h2 style="display:inline-block;" :class="{'disabledTitle' : disabledTitle}" v-text="getProductLanguage(combo, 'productGroupName')"></h2>
                <CircleButton v-if="showChangeMutexButton()" :big="true" :icon="change_white" @circleBtnClick="openSelectMutexModal(depth)"></CircleButton>
            </div>
            <div class="count" :class="{'disabledTitle' : disabledTitle}" v-text="combo?.productGroupItems.find(p => p.subItemMandatory) ? '' : buildText() "></div>
            <div class="toggleIcon">
                <fa :icon="hideGroup ? 'angle-down' : 'angle-up'"></fa>
            </div>
        </div>
        <div class="container-input-selected" :class="{'list': itemsList}" v-if="this.comboOption.find(c => c.choosen && getArrayFromChoosen(c.choosen)?.length)">
            <div v-for="(productcombo, keyproductcombo) in this.comboOption" :key="keyproductcombo" class="card-combo">
                <div v-if="productcombo.choosen" class="combo-selected">
                    <div class="selected-products">
                        <span class="customize-combo">{{ getString('personalize_seu_combo') }}</span>
                        <div class="combo-list">
                            <span class="combo-itens" v-for="(item, keyChoosen) in getArrayFromChoosen(productcombo.choosen)" :key="keyChoosen" v-text="(item.quantity ? item.quantity + 'x ' : '') + getProductLanguage(item, 'subItemName')"></span>
                        </div>
                    </div>
                    <div class="edit-button-combo" :class="{'big-mode': iconesGrandes}">
                        <CircleButton class="edit_button" :big="iconesGrandes" :icon="edit_white" @circleBtnClick="editCombo(keyproductcombo)"></CircleButton>
                        <CircleButton v-if="productcombo.subItemMandatory !== 'S'" :big="iconesGrandes" :icon="delete_white" @circleBtnClick="deleteCombo(keyproductcombo)"></CircleButton>
                    </div>
                </div>
            </div>
        </div>

        <div class="comb-prod-item-container" :class="{'hideGroup' : hideGroup }">
            <div class="item-comb-prod" v-for="(prod, key) in removeBlockedProds(combo.productGroupItems)" :key="key" :class="{'selected': hasSelected(comboOption, prod), 'style-two': allowMultipleAdd && combo.productGroupMax > 1}">
                <template v-if="allowMultipleAdd && combo.productGroupMax > 1">
                    <!-- <div class="selected-chekmark" v-if="comboOption.includes(prod)">
                        <CheckedMark class="check-mark-container"></CheckedMark>
                    </div> -->
                    <!-- <div v-if="!itemsList" class="image-label-container align-center" style="flex: 1">
                        <img v-if="prod.subItemProductImages && prod.subItemProductImages.large != null" :src="getImagesURL() + prod.subItemProductImages.large" alt="">
                        <img v-else :src="noImageSrc">
                    </div> -->

                    <label class="image-label-container"
                        :for="getCheckboxID(key, prod.subItemCode)"
                        :class="{
                            'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode),
                            'expand-width': itemsList,
                            'align-center': !itemsList
                        }">
                        <div class="info">
                          <span class="name" v-text="getProductLanguage(prod, 'subItemName')"></span>
                          <span class="price" v-if="prod.price && showChildsPrice(combo) && !isFosException(prod, combo)" v-text="getProdPrice(prod)"></span>
                        </div>
                    </label>

                    <QuantityControl
                        class="qtt"
                        :quantity="prod.quantity || 0"
                        :disabledMinus="disabledMinus(prod)"
                        @circleBtnRemove="decreaseAddQtty(prod)"
                        @circleBtnAdd="increaseAddQtty(prod, key)">
                    </QuantityControl>
                </template>

                <template v-else>
                    <label class="image-label-container"
                        :for="getCheckboxID(key, prod.subItemCode)"
                        :class="{
                            'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode),
                            'expand-width': itemsList
                        }">
                        <template v-if="!itemsList">
                            <!-- <div class="selected-chekmark" v-if="comboOption.includes(prod)">
                                <CheckedMark class="check-mark-container"></CheckedMark>
                            </div>
                            <img v-if="prod.subItemProductImages && prod.subItemProductImages.large != null" :src="prod.subItemProductImages.large" alt="">
                            <img v-else :src="noImageSrc"> -->
                        </template>

                        <div class="info two">
                          <span class="name" v-text="getProductLanguage(prod, 'subItemName')"></span>
                          <span class="price" v-show="prod.price && showChildsPrice(combo) && !isFosException(prod, combo)" v-text="getProdPrice(prod)"></span>
                        </div>

                    </label>

                    <div class="container-input">
                      <input class="styled-input"
                        :id="getCheckboxID(key, prod.subItemCode)"
                        type="checkbox"
                        :class="{'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode) }"
                        :checked="hasSelected(comboOption, prod)"
                        @change="onCheckboxChange(prod, $event)"> <!-- Evento para manipular seleção -->

                    <label class="checkmark radio" :for="getCheckboxID(key, prod.subItemCode)"
                        :class="{'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode) }">
                    </label>
                    </div>
                </template>
            </div>
        </div>

        <div class="overlay" v-if="showModal || showObservationsModal"></div>

        <Transition name="fade">
            <ModalComboDoComboGom
                v-if="showModal"
                :modalData="modalData"
                @modalCancel="modalCancel"
                @modalConfirm="modalConfirm">
            </ModalComboDoComboGom>
        </Transition>

        <Transition name="bounce">
            <ObservationsModalGom
                v-if="showObservationsModal"
                :obsModalProd="obsModalProd"
                @obsModalClose="obsModalClose">
            </ObservationsModalGom>
        </Transition>
      </div>
</template>

<script>
import Util from '@/assets/libs/util.js'
import LocaleController from '@/assets/controllers/LocaleController'
// import CheckedMark from '@/components/CheckedMark.vue'
import CircleButton from '@/components/buttons/CircleButton'
import QuantityControl from '@/components/QuantityControl'
import ObservationsModalGom from '@/components/modals/ObservationsModalGom'
import ModalComboDoComboGom from '@/components/modals/ModalComboDoComboGom.vue'

export default {
  name: 'AdcComp',
  components: {
    // CheckedMark,
    QuantityControl,
    CircleButton,
    ObservationsModalGom,
    ModalComboDoComboGom
  },
  props: ['combo', 'chosen', 'fatherProdCode', 'fatherPrint', 'zindex', 'depth', 'curComboKey', 'mutexData', 'isEditing', 'blockProds', 'alternativeLayoutCounter'],
  data () {
    return {
      allowMultipleAdd: true,
      comboOption: this.chosen || [],
      hideGroup: false,
      disabledTitle: false,
      showModal: false,
      modalData: null,
      obsModalProd: null,
      showObservationsModal: false,
      noImageSrc: null,
      useAlternativeLayout: true,
      itemsList: false,
      iconesGrandes: false,
      edit_white: require('../../static/icons/edit_white.svg'),
      change_white: require('../../static/icons/change_white.svg'),
      delete_white: require('../../static/icons/delete_white.svg')
    }
  },
  mounted () {
    this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk

    if (!this.isEditing) {
      setTimeout(() => {
        this.fillPreselectedProducts(this.combo.productGroupItems, this.combo.productGroupMax, this.combo.productGroupMin)
      }, 500)
    }
    this.evaluateHideGroup()
    this.fillCheckboxes()
    setTimeout(() => {
      const groupDiv = document.getElementById('curProd-0')
      if (groupDiv) groupDiv.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 600)
  },
  methods: {
    getString: function (key) {
      return LocaleController.getString(key)
    },
    getImagesURL: function () {
      return Util.getLocalConfigs('urlIMGOdhenInterface')
    },
    getGroupNumber: function () {
      /* if (this.useAlternativeLayout) {
                return this.alternativeLayoutCounter
            } else {
                return this.depth + 1
            } */
      return this.depth + 1
    },
    getProdPrice: function (prod) {
      const showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
      const groupHasMinPrice = this.combo && this.combo.minPrice != null
      let price = 0

      if (showMinPriceDifference && groupHasMinPrice) {
        price = this.formatMoney(prod.price - this.combo.minPrice)
      } else {
        price = this.formatMoney(prod.price)
      }

      return ` + ${price}`
    },
    isSelected: function (key, subItemCode) {
      const id = this.getCheckboxID(key, subItemCode)
      const element = document.getElementById(id)
      return element && element.checked
    },
    checkNextPreselect: function (jumpingToGroupNumber) {
      if (this.depth === jumpingToGroupNumber) {
        if (!this.isEditing) {
          this.fillPreselectedProducts(this.combo.productGroupItems, this.combo.productGroupMax, this.combo.productGroupMin, jumpingToGroupNumber)
        }
      }
    },
    checkHideGroup: function (groupKey) {
      const hideGroupOnMax = Util.getLocalConfigs('hideGroupOnMax')
      if (hideGroupOnMax && this.depth === groupKey && !this.hideGroup) {
        this.toggleHideGroup()
      }
    },
    deleteAllChoices: function (groupKey) {
      if (this.depth === groupKey) {
        if (this.allowMultipleAdd && this.combo.productGroupMax > 1) {
          for (let i = this.comboOption.length; i > 0; i--) {
            const prod = this.comboOption[i - 1]
            const quantity = prod.quantity || 1

            for (let i = 0; i < quantity; i++) {
              this.decreaseAddQtty(prod)
            }
          }
        } else if (this.comboOption && this.comboOption.length > 0) {
          this.comboOption = []
          this.emitComboOption(this.comboOption, this.depth)
        }
      }
    },
    removeBlockedProds: function (prods) {
      return Util.removeBlockedProds(prods)
    },
    getCheckboxID: function (key, subItemCode) {
      const id = [this.depth, key, subItemCode]
      return id.join('')
    },
    disabledMinus: function (prod) {
      return prod.subItemProductGroups.length > 0 // && prod.quantity > 0
    },
    getArrayFromChoosen: function (choosen) {
      return Util.flatAnObjectList(choosen)
    },
    modalCancel: function (clickedElementId) {
      const clickedElement = document.getElementById(clickedElementId)
      if (clickedElement && clickedElement.checked) clickedElement.checked = false
      this.clearCheckboxes()
      this.fillCheckboxes()
      this.showModal = false
      this.emitComboOption(this.comboOption, this.depth)
    },
    modalConfirm: function (option) {
      if (option.edit) {
        const key = option.key
        this.comboOption.splice(key, 1)
      }

      // O produto que chega em option é uma cópia (deepCopy). Para incrementar o contador de quantidade no front
      // é preciso incrementar a quantidade do produto no array original
      const originalProd = this.combo.productGroupItems[option.prodIndex]
      if (originalProd && originalProd.quantity) {
        if (!option.edit) {
          originalProd.quantity++
        }
      } else if (originalProd) {
        originalProd.quantity = 1
      }

      this.comboOption.push(option)
      // console.log(this.comboOption)
      this.emitComboOption(this.comboOption, this.depth)
      this.clearCheckboxes()
      this.fillCheckboxes()
      this.showModal = false
    },
    obsModalClose: function (obsModalProd) {
      this.comboOption.push(obsModalProd)
      this.emitComboOption(this.comboOption, this.depth)
      this.showObservationsModal = false
    },
    toggleHideGroup: function () {
      this.hideGroup = !this.hideGroup
      /* if (!this.useAlternativeLayout) {
                let isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
                let hasAnyMutexSelected = this.mutexData[this.combo.productGroupMutex] && this.mutexData[this.combo.productGroupMutex].selectedMutexCode != null
                let isSelectedMutex = this.mutexData[this.combo.productGroupMutex] && this.combo.productGroupCode === this.mutexData[this.combo.productGroupMutex].selectedMutexCode

                if (!isMutexGroup || !hasAnyMutexSelected || isSelectedMutex) {
                    this.hideGroup = !this.hideGroup
                }
            } */
    },
    evaluateHideGroup: function () {
      /* if (!this.useAlternativeLayout) {
                let isSingleProdPreselec = this.combo.productGroupItems.length === 1 && this.combo.productGroupItems[0].subItemPreSelected === 'S'
                let isOptionalGroup = this.combo.productGroupMin === 0
                let isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
                let isFirstMutexGroup = isMutexGroup && this.mutexData[this.combo.productGroupMutex].groups[0].productGroupCode === this.combo.productGroupCode
                let hasAnyMutexSelected = this.mutexData[this.combo.productGroupMutex] && this.mutexData[this.combo.productGroupMutex].selectedMutexCode != null
                let isSelectedMutex = this.mutexData[this.combo.productGroupMutex] && this.combo.productGroupCode === this.mutexData[this.combo.productGroupMutex].selectedMutexCode

                if (isSingleProdPreselec || isOptionalGroup || isMutexGroup) {
                    this.hideGroup = true
                    if (isMutexGroup && hasAnyMutexSelected && !isSelectedMutex) {
                        this.disabledTitle = true
                    }
                }

                if ((isFirstMutexGroup && !hasAnyMutexSelected) || (isMutexGroup && hasAnyMutexSelected && isSelectedMutex)) {
                    this.hideGroup = false
                }
            } */
    },
    fillPreselectedProducts: function (productGroupItems, groupMax, groupMin, depth = 0) {
      const filteredProductGroupItems = Util.removeBlockedProds(productGroupItems)

      filteredProductGroupItems.forEach(product => {
        if (product.subItemPreSelected === 'S' && (groupMax === 1 || groupMax === groupMin)) {
          this.onProdChoose(product, 'preselected')
        }
      })
    },
    formatMoney: function (price) {
      return Util.formatMoney(price)
    },
    emitComboOption: function (option, key) {
      this.$emit('comboOption', { option: option, key: key })
    },
    clearCheckboxes: function () {
      if (this.combo.productGroupItems && this.combo.productGroupItems.length > 0) {
        this.combo.productGroupItems.forEach((prod, index) => {
          const isSelected = this.comboOption.find(element => element.subItemCode === prod.subItemCode)

          if (!isSelected) {
            const id = '' + this.depth + index + prod.subItemCode
            const clickedElement = document.getElementById(id)
            if (clickedElement && clickedElement.checked) clickedElement.checked = false
          }
        })
      }
    },
    fillCheckboxes: function () {
      if (this.comboOption && this.comboOption.length > 0) {
        this.comboOption.forEach(option => {
          if (this.combo.productGroupMax === this.combo.productGroupMin && option.subItemMandatory === option.subItemPreSelected && option.subItemPreSelected === 'S') {
            option.quantity = this.combo.productGroupMax
          }
          const index = (this.combo.productGroupItems || []).findIndex(el => el.subItemCode === option.subItemCode)
          const id = '' + this.depth + index + option.subItemCode
          const clickedElement = document.getElementById(id)
          if (clickedElement && !clickedElement.checked) clickedElement.checked = true
        })
      }
    },
    prepareModal: function (prod, event, prodIndex) {
      this.modalData = prod
      this.modalData.firstLevelFatherPrint = this.fatherPrint
      this.modalData.fatherPrint = this.combo.productGroupPrint
      if (event && event !== 'preselected') {
        const clickedElementId = event.srcElement.id
        this.modalData.clickedElementId = clickedElementId
      }
      if (prodIndex != null) {
        this.modalData.prodIndex = prodIndex
      }
      this.showModal = true
    },
    onProdChoose: function (prod, event) {
      const comboDoCombo = Util.isComboDoCombo(prod, this.fatherProdCode)
      const canSelectOnlyOne = this.combo.productGroupMax === 1 || this.combo.productGroupMax === this.combo.productGroupMin
      const isChecked = event === 'preselected' ? true : event && event.srcElement.checked
      const hasObservations = (prod.subItemObservationsChoice || []).length > 0
      const typedObsEnabled = Util.getLocalConfigs('permiteObsDigitada')

      if (comboDoCombo) {
        this.comboOption = this.comboOption.filter(cop => cop !== prod)
        const canSelectMore = this.comboOption.length < this.combo.productGroupMax

        if (canSelectOnlyOne) {
          this.comboOption = []
          if ((event && event === 'preselected') || (event && event.srcElement.checked)) {
            this.prepareModal(prod, event)
          } else {
            this.emitComboOption(this.comboOption, this.depth)
          }
        } else if (canSelectMore && isChecked) {
          this.prepareModal(prod, event)
        } else {
          event.srcElement.checked = true
        }
      } else if (hasObservations || typedObsEnabled) {
        const canSelectMore = this.comboOption.length <= this.combo.productGroupMax

        if (canSelectOnlyOne) {
          this.comboOption = []
          if ((event && event === 'preselected') || prod.subItemMandatory === 'S' || (event && event.srcElement.checked)) {
            this.obsModalProd = prod
            // this.showObservationsModal = true
            this.clearCheckboxes()
            this.fillCheckboxes()
            const delay = event === 'preselected' ? 800 : 200
            setTimeout(() => {
              this.showObservationsModal = true
            }, delay)
          } else {
            this.emitComboOption(this.comboOption, this.depth)
          }
        } else if (!canSelectMore) {
          this.comboOption.pop()
          event.srcElement.checked = false
        }
      } else {
        const canSelectMore = this.comboOption.length <= this.combo.productGroupMax
        if (canSelectOnlyOne) {
          this.comboOption = []
          if ((event && event === 'preselected') || prod.subItemMandatory === 'S' || (event && event.srcElement.checked)) {
            this.comboOption.push(prod)
            this.clearCheckboxes()
            this.fillCheckboxes()
          } else {
            this.emitComboOption(this.comboOption, this.depth)
          }
        } else if (!canSelectMore) {
          this.comboOption.pop()
          event.srcElement.checked = false
        }

        this.emitComboOption(this.comboOption, this.depth)
      }
      // console.log(this.comboOption)
    },

    increaseAddQtty: function (prod, prodIndex) {
      const comboDoCombo = Util.isComboDoCombo(prod, this.fatherProdCode)
      const hasObservations = (prod.subItemObservationsChoice || []).length > 0
      const typedObsEnabled = Util.getLocalConfigs('permiteObsDigitada')

      if (comboDoCombo) {
        let totalGroupItens = 0
        this.comboOption.forEach(option => {
          if (option.quantity) {
            totalGroupItens += option.quantity
          } else {
            totalGroupItens++
          }
        })
        // eslint-disable-next-line
        if (totalGroupItens == this.combo.productGroupMax) {
          Util.showErrorNotification({ title: this.getString('atingiu_limite_categoria'), text: null })
          return
        }
        this.prepareModal(prod, null, prodIndex)
      } else {
        const thisProdIndex = this.comboOption.findIndex(element => element.subItemCode === prod.subItemCode)

        if (!prod.quantity) {
          prod.quantity = 0
        }

        const maxItens = this.combo.productGroupMax
        let totalGroupItens = 0
        this.comboOption.forEach(option => {
          if (option.quantity) {
            totalGroupItens += option.quantity
          } else {
            totalGroupItens++
          }
        })

        if (totalGroupItens < maxItens) {
          prod.quantity++
          this.$forceUpdate()

          if (thisProdIndex === -1) {
            if (hasObservations || typedObsEnabled) {
              this.obsModalProd = prod
              this.showObservationsModal = true
              return true
            } else {
              this.comboOption.push(prod)
            }
          } else {
            this.comboOption[thisProdIndex].quantity = prod.quantity
          }
          this.emitComboOption(this.comboOption, this.depth)
        } else {
          Util.showErrorNotification({ title: this.getString('atingiu_limite_categoria'), text: null })
        }
      }
      this.$emit('updateComboPrice')
    },
    decreaseAddQtty: function (prod) {
      const comboDoCombo = Util.isComboDoCombo(prod, this.fatherProdCode)
      if (!comboDoCombo) {
        const thisProdIndex = this.comboOption.findIndex(element => element.subItemCode === prod.subItemCode)
        const minItens = this.combo.productGroupMin

        if (prod.quantity === minItens && this.combo.productGroupItems.length === 1) {
          Util.showErrorNotification({ title: this.getString('limite_minimo_categoria'), text: null })
        } else if (prod.quantity && prod.quantity > 0) {
          prod.quantity--
          this.decreaseReferenceProdQuantity(prod)
        }
        this.$forceUpdate()

        if (thisProdIndex !== -1) {
          this.comboOption[thisProdIndex].quantity = prod.quantity
          if (this.comboOption[thisProdIndex].quantity === 0) {
            this.comboOption.splice(thisProdIndex, 1)
          }
        }
        this.emitComboOption(this.comboOption, this.depth)
      }
    },
    decreaseReferenceProdQuantity: function (prod) {
      if (this.combo.productGroupItems && this.combo.productGroupItems.length > 0) {
        const index = this.combo.productGroupItems.findIndex(element => element.subItemCode === prod.subItemCode)
        if (index !== -1) {
          // eslint-disable-next-line
          this.combo.productGroupItems[index].quantity = prod.quantity
        }
      }
    },
    getCurQnt: function () {
      return this.comboOption.length || this.comboOption.productCode ? 1 : 0
    },
    buildText: function () {
      const text1 = this.getString('escolha')
      let text2 = ''

      if (this.combo.productGroupMin === this.combo.productGroupMax) {
        text2 = this.combo.productGroupMax
      } else {
        text2 = this.getString('ate') + ` ${this.combo.productGroupMax}`
      }

      const text3 = this.combo.productGroupMax === 1 ? this.getString('opcao') : this.getString('opcoes')

      return text1 + text2 + text3
    },
    showChildsPrice: function (comboGroup) {
      if (this.fatherPrint === 'S' && comboGroup.productGroupPrint === 'S') {
        // Se o produto principal (pai) é imprime sim e o grupo promocional também é imprime sim, deve exibir o preço dos filhos
        return true
      } else if (this.fatherPrint === 'N') {
        // Se o produto principal (pai) é imprime não, sempre deve exibir o preço dos itens filhos
        return true
      } else {
        return false
      }
    },
    isFosException: function (product, group) {
      const firstLevelComboPrint = this.fatherPrint === 'S'
      const groupPrint = group && group.productGroupPrint === 'S'
      return Util.isFosException(product, this.fatherProdCode, firstLevelComboPrint, groupPrint)
    },
    editCombo: function (keySelected) {
      const comboSelected = this.comboOption[keySelected]
      comboSelected.edit = true
      comboSelected.key = keySelected
      this.modalData = comboSelected
      this.modalData.fatherPrint = this.combo.productGroupPrint
      this.showModal = true
    },
    deleteCombo: function (keySelected) {
      const clickedElementId = this.comboOption[keySelected].clickedElementId
      const clickedElement = document.getElementById(clickedElementId)
      if (clickedElement && clickedElement.checked) clickedElement.checked = false

      const thisProdIndex = this.comboOption[keySelected].prodIndex
      const originalProd = this.combo.productGroupItems[thisProdIndex]
      if (originalProd && originalProd.quantity && originalProd.quantity > 0) {
        originalProd.quantity--

        const isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
        const hasAnyMutexSelected = this.mutexData[this.combo.productGroupMutex] && this.mutexData[this.combo.productGroupMutex].selectedMutexCode != null
        const isSelectedMutex = this.mutexData[this.combo.productGroupMutex] && this.combo.productGroupCode === this.mutexData[this.combo.productGroupMutex].selectedMutexCode

        if (originalProd.quantity === 0 && isMutexGroup && hasAnyMutexSelected && isSelectedMutex) {
          this.$emit('clearSelectedMutex', this.mutexData[this.combo.productGroupMutex])
        }
      }

      this.comboOption.splice(keySelected, 1)
      this.$emit('updateComboPrice')
      this.$emit('updateNextButton')
    },
    showChangeMutexButton: function () {
      // console.log(this.combo.productGroupMutex, this.mutexData[this.combo.productGroupMutex])
      if (this.combo && this.combo.productGroupMutex) {
        const mutexGroup = this.combo.productGroupMutex
        if (this.mutexData && this.mutexData[mutexGroup]) {
          return true
        }
      }

      return false
    },
    openSelectMutexModal: function (oldProductGroupCode) {
      const mutexKey = this.combo.productGroupMutex
      this.$emit('openSelectMutexModal', mutexKey, false, oldProductGroupCode)
    },
    getProductLanguage: function (product, index) {
      return LocaleController.getIndexLanguages(product, index)
    },
    isAndroidMode: function () {
      return Util.isAndroidMode()
    },
    hasSelected: function (comboOption, prod) {
    // Verifica se o comboOption já inclui o produto com base no subItemCode
      return comboOption.some(option => option.subItemCode === prod.subItemCode)
    },
    onCheckboxChange: function (prod, event) {
      const isChecked = event.target.checked

      const selectedCount = this.comboOption.length

      if (this.combo.productGroupMax === 1 && isChecked) {
        this.comboOption = []
      }

      if (isChecked) {
        if (selectedCount >= this.combo.productGroupMax) {
          event.target.checked = false
          this.$forceUpdate()
          // return
        }

        const hasObservations = (prod.subItemObservationsChoice || []).length > 0
        const typedObsEnabled = Util.getLocalConfigs('permiteObsDigitada')

        if (hasObservations || typedObsEnabled) {
          this.obsModalProd = prod
          this.showObservationsModal = true
        } else {
          this.comboOption.push(prod)
        }
      } else {
        const index = this.comboOption.findIndex(option => option.subItemCode === prod.subItemCode)
        if (index !== -1) {
          this.comboOption.splice(index, 1)
        }
      }

      this.emitComboOption(this.comboOption, this.depth)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
 @import (reference) url("../assets/common.less");
    .wizardStep {
        background: white;

        .hideGroup {
            display: none !important;
        }
        .price{
            font-family: @default-font;
            font-size: 25px;
            color: red;
            margin: 0;
        }
        .title-container{
            display: grid;
            grid-template-columns: 60% 30% 10%;
            border-radius: 15px 15px 0 0;
            margin-top: 20px;
            overflow: hidden;
            position: relative;
            &:before {
              z-index: 0;
              opacity: .2;
              background: var(--primaryColor);
              position: absolute;
              content: '';
              bottom: 0;
              right: 0;
              left: 0;
              top: 0;
            }
            h2 {
                padding: 0;
                font-size: calc(0.8vw + 1.4vh);
                word-break: break-word;
            }
            .left-part-title {
              display: flex;
              align-items: center;
              width: 100%;

              .circle {
                width: 40px;
                height: 40px;
                text-align: center;
                align-content: center;
                padding: 10px 10px 10px 5px;
                font-size: 1.3em;
              }
            }

            .count {
                color: var(--primaryColor);
                font-size: 0.9em;
                margin: auto;
                margin-left: 15px;
                padding: 7px;
                font-weight: 600;
                border-radius: 10px;
            }

            .toggleIcon {
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .disabledTitle {
                color: @disabled-color;
            }
        }

        .comb-prod-item-container{
            display: flex;
            justify-content: space-evenly;
            flex-wrap: wrap;
            border-bottom: 1px solid #eed0c4;
            margin-bottom: 20px;
            margin-top: 10px;

            &:last-child {
                border-bottom: none;
            }

            .item-comb-prod {
                width: 100%;
                display: grid;
                grid-template-columns: calc(100% - 60px) 60px;
                // align-items: center;
                margin-top: 0;
                padding-left: 0;
                margin-bottom: 15px;

                .image-label-container {
                    display: flex;

                    img {
                        // max-height: 300px;
                        margin: auto;
                        object-fit: contain;
                        padding-bottom: 10px;
                        border-radius: 5px;
                        display: none;
                        width: 0;
                    }

                    .info {
                        display: flex;
                        flex-direction: flex-start;
                        justify-content: flex-start;
                        align-items: center;
                        width: 100%;
                        .name {
                            color: #8D8D8D;
                            font-size: 11px;
                            font-weight: bold;
                            padding: 10px 0;
                            word-break: break-word;
                            margin-right: 20px;
                        }
                        .price {
                            color: #C0C0C0;
                            font-size: 11px;
                            font-weight: bold;
                            text-align: center;
                            padding: 10px 0;
                        }
                    }

                    .two {
                      position: relative;
                      display: grid;
                      grid-template-columns: 80% 20%;
                    }
                }

                .container-input {
                  position: relative;
                  margin-top: 5px;
                  input {
                    z-index: 1;
                    opacity: 0;
                  }
                  .checkmark {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    left: 1;
                    top: 0;
                    border: solid 1px var(--primaryColor);
                    width: 24px;
                    height: 24px;
                    border-radius: 5px;
                  }

                  input:checked + .checkmark {
                    &:after {
                      border-radius: 5px;
                      content: '';
                      margin: auto;
                      position: absolute;
                      bottom: 0;
                      right: 0;
                      left: 0;
                      top: 0;
                      width: 20px;
                      height: 20px;
                      background: var(--primaryColor);
                    }
                  }
                }

                .align-center {
                    align-items: center;
                }

                .expand-width {
                    width: 100% !important;
                }
                &.selected {
                    // background-color: rgba(128, 128, 128, 0.1);
                    .selected-chekmark {
                        position: relative;
                        display: flex;
                        justify-content: end;
                        margin: 0;
                        width: 100%;
                        height: 40px;
                        .check-mark-container {
                            display: flex;
                            padding-top: 10px;
                            justify-content: center;
                            border-bottom-left-radius: 50%;
                        }
                    }
                    .image-label-container {
                        img {
                            margin-top: -40px;
                        }
                    }
                }
            }

            // style two
            .style-two {
              display: grid;
              grid-template-columns: calc(100% - 100px) 100px;
            }
        }

        .overlay {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.8);
            z-index: 10;
        }

        .container-input-selected {
            display: grid;
            margin: 10px 5px 0 5px;
            grid-template-columns: 46% 46%;
            column-gap: 20px;
            padding-bottom: 30px;
            font-size: 14px;
            justify-content: space-between;
            gap: 18px;

            .combo-selected {
                border-top: 4px solid #eed0c4;
                -webkit-box-shadow: 7px 0 7px rgba(0, 0, 0, 0.1);
                box-shadow: 7px 0 7px rgba(0, 0, 0, 0.1);
                width: 100%;
                position: relative;
                min-height: inherit;
                display: grid;
                grid-template-rows: auto 40px;
                span {
                    display: block;
                }
                .selected-products {
                    padding: 10px 5px 5px 10px;
                    min-height: 100px;
                    .combo-list {
                        padding-left: 13px;
                    }
                }
            }
            .card-combo {
                // border-bottom: 85px solid #eed0c4;
                display: grid;
                margin-bottom: 0;
            }
            .combo-itens {
                font-size: 14px;
                color: #524f4f;
            }
            .customize-combo {
                font-weight: bold;
                padding-bottom: 7px;
            }
            .edit-button-combo {
                // position: absolute;
                display: flex;
                width: -webkit-fill-available;
                justify-content: flex-end;
                height: 40px;
                margin-top: 9px;
                margin-bottom: -5px;
                align-items: center;
                box-shadow: 7px 0 7px rgba(0, 0, 0, 0.1);
                background-color: #eed0c4;
                button {
                    margin: 5px;
                }
            }
            .edit-button-combo.big-mode {
                padding-left: 60%;
                bottom: -74px;
            }
            &.list {
                padding-bottom:0;
            }
        }

        .disabled-click {
            pointer-events: none
        }
    }
</style>
